var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-data"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }